import { AmountString, Amounts, TranslatedString } from "@gnu-taler/taler-util";
import { VNode, h } from "preact";
import { UIFormProps } from "../FormProvider.js";
import { InputLine } from "./InputLine.js";

export function InputAmount(
  props: { currency: string } & UIFormProps<AmountString>,
): VNode {
  return (
    <InputLine
      {...props}
      type="text"
      before={{
        type: "text",
        text: props.currency as TranslatedString,
      }}
      //@ts-ignore
      converter={
        props.converter ?? {
          fromStringUI: (v): AmountString | undefined => {
            if (!v) return undefined;
            const amount = Amounts.parse(`${props.currency}:${v}`);
            return amount ? Amounts.stringify(amount) : undefined;
          },
          toStringUI: (v: AmountString) => {
            return v === undefined ? "" : Amounts.stringifyValue(v);
          },
        }
      }
    />
  );
}
